import { render, staticRenderFns } from "./PageForm.vue?vue&type=template&id=a7ac074a&scoped=true&"
import script from "./PageForm.vue?vue&type=script&lang=js&"
export * from "./PageForm.vue?vue&type=script&lang=js&"
import style0 from "./PageForm.vue?vue&type=style&index=0&id=a7ac074a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ac074a",
  null
  
)

export default component.exports